module.exports = __webpack_public_path__ + "mapPin-primary.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mapPin-primary.png
// module id = 1960
// module chunks = 4